import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { PopoverController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { MbsFulldescriptionComponent } from 'src/app/components/mbs-fulldescription/mbs-fulldescription.component';
import { AccessService } from 'src/app/providers/access/access.service';

@Component({
  selector: 'app-mbs-lookup',
  templateUrl: './mbs-lookup.page.html',
  styleUrls: ['./mbs-lookup.page.scss'],
})
export class MbsLookupPage implements OnInit {
  hasSkelton = true;
  unreadCount: any;
  mbsList: any = [];
  searchTerm: '';
  filtereditems: any[] = [];
  fitleredTitles: any[] = [];
  fitleredDesc: any[] = [];
  page = 1;
  perPage = 10;
  hasMore = true;
  mbsListType = 'all';
  constructor(
    private apiService: ApiService,
    public router: Router,
    public popoverController: PopoverController, 
    public modalController: ModalController,
    public toastService: ToastService,
    public accessService: AccessService,
  ) {
    this.getnotificationCount();
    
  }

  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  ngOnInit() {
    this.getmbsData();
  }


  getnotificationCount() {
    this.apiService
      .post('user/get-unread-notification-count', {})
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }


  getmbsData() {
    const params = {
      page: this.page,
      perPage: this.perPage,
      status: this.mbsListType
    };
    this.filtereditems = [];
    this.hasSkelton = true;

    this.apiService.post('user/mbs-list', params).subscribe(
      (res) => {
        this.hasSkelton = false;
        if (res.error === false){
          this.mbsList = res.data.mbs;
          this.filtereditems = this.mbsList;
          if (this.mbsList.length < this.perPage) {
            this.hasMore = false;
          } else {
            this.page++;
          }
        }
      },
      (err) => {
        this.hasSkelton = false;
        //console.log(err);
      }
    );
  }

  doInfinite(infiniteScroll) {
    this.page++;
    infiniteScroll.target.complete();
  }

  onSearch(event: any) {
    if (!event) {
      this.filtereditems = this.mbsList;
    }
    const newValue =
      event.target.value && event.target.value.trim().toLowerCase();
    if (!newValue || !this.mbsList) {
      this.filtereditems = this.mbsList;
    } else {
      if (
        this.mbsList.length > 0 &&
        typeof this.mbsList[0].Mbs.Description != 'undefined'
      ) {
        this.fitleredTitles = this.mbsList.filter(
          (item) =>
            item.Mbs.ItemNum.toLowerCase().indexOf(newValue) > -1
        );
        this.fitleredDesc = this.mbsList.filter(
          (item) =>
            item.Mbs.Description.toLowerCase().indexOf(newValue) > -1
        );
        this.filtereditems = this.fitleredTitles.concat(this.fitleredDesc);
      }
    }
  }

  segmentChanged(ev: any) {
    //console.log('Segment changed', ev.detail.value);
    this.mbsListType = ev.detail.value;
    this.page = 1;
    this.hasMore = true;
    this.getmbsData();
  }

  addMbsFavorite(mbs) {
    const params = {
      item: mbs.Mbs.ItemNum
    };
    this.toastService.presentLoading();
    this.apiService.post('user/add-mbs-favourite', params).subscribe(
      (res) => {
        this.toastService.dismissLoading();
        if (!res.error) {
          mbs.is_favorite = true;
          this.toastService.presentToast(
            'success', res.message
          );
        }
        else {
          this.toastService.presentToast(
            'error', res.message
          );
        }
      }, (err) => { this.toastService.dismissLoading(); });
  }
  removeMbsFavorite(mbs) {
    const params = {
      item: mbs.Mbs.ItemNum
    };
    this.toastService.presentLoading();
    this.apiService.post('user/remove-mbs-favourite', params).subscribe(
      (res) => {
        this.toastService.dismissLoading();
        if (!res.error) {
          mbs.is_favorite = false;
          // this.getmbsData();
          this.toastService.presentToast(
            'success', res.message
          );
        }
        else {
          this.toastService.presentToast(
            'error', res.message
          );
        }
      }, (err) => { this.toastService.dismissLoading(); });
  }

  openFullDescription(description) {
    this.toastService.presentLoading();
    this.popoverController.create({
      component: MbsFulldescriptionComponent,      
      componentProps: {mbsitem: description,
    },
      cssClass: 'billing-modal',
      showBackdrop: true,
      backdropDismiss: true
    }).then(res => {
      this.toastService.dismissLoading();
      res.present();      
    });
  }
}
